// Profile ENUM
export const PROFILE_STATS_COMPONENT_ACTIONS = {
  GENERAL_STATS: 'general_stats',
  RANK: 'rank',
  ACTIVITY: 'activity',
};

export const PROFILE_KEYS = {
  CURRENT: 'current',
  OPPONENT: 'opponent',
};
